import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import GenericPromises from '../../../../../api/GenericPromises';
import { FormsErrors } from '../../../../../hooks/Forms/FormsErrors';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { TextField } from '@mui/material';
import { PrimaryButton } from '../../../../../theme/buttons';
import { SnackbarComponent } from '../../../../../components/Commons/SnackBar';
import { DriverType } from '../../../../../interfaces/Sales/Catalogs/TransportationDocuments/driverTypes';
import useSnackBar from '../../../../../components/Commons/SnackBar/useSnackBar';

export const UpdateDriverTypes = ({ ...props }) => {
    const [t] = useTranslation("global");
    const { GenericPutResource } = GenericPromises();
    const { showSnackBar, SnackbarComponent } = useSnackBar();
    const { GetError } = FormsErrors();
    const [loadingPost, setLoadingPost] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const { driverTypePayload } = props;
    const isEdit = !props.isEdit;

    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm<DriverType>({
        defaultValues: {
            driver_type_code: '',
            driver_type_name: '',
        }
    });
    const onSubmit: SubmitHandler<DriverType> = (data) => onPut(data);

    const onPut = (data: DriverType) => {
        let myData = {
            driver_type_code: data.driver_type_code,
            driver_type_name: data.driver_type_name,
        }
        setLoadingPost(true);
        GenericPutResource(`/drivertypes/${driverTypePayload.driver_type_id}`, myData)
            .then((response) => {
                showSnackBar(t("generic.snackbar.update"), "success");
                setLoadingPost(false);
            })
            .catch((error) => {
                setLoadingPost(false);
                showSnackBar(error.message, 'error');
            });
    }

    useEffect(() => {
        reset({
            driver_type_code: driverTypePayload.driver_type_code,
            driver_type_name: driverTypePayload.driver_type_name,
        });
        setDataLoaded(true);
    }, []);

    return (
        <>
            {dataLoaded &&
                <div className='d-flex justify-content-center'>
                    <div className='custom-card-view w-75'>

                        <form onSubmit={handleSubmit(onSubmit)} className='mt-4'>

                            <div className="custom-card-row d-flex justify-content-between">

                                <div className="w-100">
                                    <div className='d-flex w-100'>
                                        <div className='w-50'>
                                            <Controller
                                                name="driver_type_code"
                                                control={control}
                                                rules={{ required: true, maxLength: 10 }}
                                                render={({ field }) =>
                                                    <TextField
                                                        variant="filled"
                                                        label={`${t("drivertypes.fields.driver_type_code")}`}
                                                        ref={field.ref}
                                                        value={field.value}
                                                        onChange={(event) => { field.onChange(event.target.value) }}
                                                        error={!!errors.driver_type_code}
                                                        helperText={GetError(errors.driver_type_code?.type)}
                                                        size="small"
                                                        style={{ width: "100%" }}
                                                        sx={{ paddingRight: 2 }}
                                                        disabled={isEdit}
                                                    />
                                                }
                                            />
                                        </div>
                                        <div className='w-50'>
                                            <Controller
                                                name="driver_type_name"
                                                control={control}
                                                rules={{ required: true, maxLength: 150 }}
                                                render={({ field }) =>
                                                    <TextField
                                                        variant="filled"
                                                        label={`${t("drivertypes.fields.driver_type_name")}`}
                                                        ref={field.ref}
                                                        value={field.value}
                                                        onChange={(event) => { field.onChange(event.target.value) }}
                                                        error={!!errors.driver_type_name}
                                                        helperText={GetError(errors.driver_type_name?.type)}
                                                        size="small"
                                                        style={{ width: "100%" }}
                                                    />
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {!isEdit &&
                                <div className='d-flex flex-row-reverse mt-4'>
                                    <PrimaryButton type='submit' variant='outlined' className='m-1' disabled={loadingPost}>{t("generic.buttons.update")}</PrimaryButton>
                                </div>
                            }

                        </form>

                    </div>
                </div>
            }
            <SnackbarComponent />
        </>
    )
}
